(function() {
  "use strict";

  angular

    .module('modules.forms', ['ngMessages', 'modules.analytics']);

})();